// ========================================
// Configuration for Vercel deployment
// ========================================
// Frontend and API are on the same Vercel domain.
// API calls use relative paths -- no cross-origin issues.
// ========================================

const config = {
  // Environment detection
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',

  // API Configuration -- relative path since same domain on Vercel
  api: {
    baseURL: '',  // empty string = relative (same origin)
    timeout: 300000, // 5 minutes
    retryAttempts: 3,
    retryDelay: 1000,
  },

  // External APIs (only used by frontend for display, actual calls go through API)
  external: {
    apify: {
      baseURL: 'https://api.apify.com/v2'
    },
    openai: {
      model: 'gpt-4o-mini'
    }
  },

  // Database Configuration (frontend read-only via Supabase JS client)
  database: {
    supabase: {
      url: process.env.REACT_APP_SUPABASE_URL,
      publishableKey: process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY
    }
  },

  // Application Settings
  app: {
    name: 'Google Reviews Dashboard',
    version: '2.0.0',
    maxReviewsPerScrape: 7000,
    defaultLanguage: 'ar',
    paginationLimit: 50,

    features: {
      aiAnalysis: true,
      export: true,
      cronPipeline: true   // New: automated cron pipeline
    }
  }
};

// Helper functions
config.getApiURL = (endpoint = '') => {
  const cleanEndpoint = endpoint.replace(/^\//, '');
  return cleanEndpoint ? `/${cleanEndpoint}` : '';
};

// Log config
console.log('Frontend Configuration:', {
  Environment: config.isProduction ? 'PRODUCTION' : 'DEVELOPMENT',
  API_URL: config.api.baseURL || '(relative - same origin)',
  Version: config.app.version
});

// Export configuration
export default config;
